import sandbox from './sandbox';
import user from './user';
export default {
    sandbox: sandbox,
    user: user,
};
